module.exports = "section {\n  overflow: hidden;\n}\n.pad {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n"